export default __webpack_public_path__ + "static/media/16_photo.1a006763.jpg";